module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.request,
      "message200": false,
      "message401": null,
      "message404": "Could not find a matching incoming notification from JotForm - some fields may not be formatted correctly"
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "py-1 overline grey lighten-4"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": "",
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.getSubmission
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v("\n    Submission:\n    "), _c('v-spacer'), _vm._v(" "), (_vm.withClose) ? _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": _vm.request.status === 401,
      "text": ""
    }
  }, [_vm._v("\n    Unable to fetch this response from JotForm (permission denied).\n    Have you uninstalled the integration or changed your API key?\n    "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Open submission in JotForm")])]), _vm._v(" "), (_vm.submission && _vm.submission.id) ? _c('v-card', [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      Answers\n      "), _c('v-spacer'), _vm._v(" "), (_vm.submissionLink) ? _c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "href": _vm.submissionLink,
      "target": "_blank"
    }
  }, [_vm._v("\n        Open in JotForm\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.submission.answers), function(answer, index) {
    return [(answer.answer) ? [_c('v-card', {
      key: ((_vm.submission.id) + "-" + (answer.name)),
      attrs: {
        "flat": ""
      }
    }, [(answer.type === 'control_head') ? _c('v-subheader', [_vm._v(_vm._s(answer.text))]) : _vm._e(), _vm._v(" "), (answer.type === 'control_divider') ? _c('v-divider') : _vm._e(), _vm._v(" "), (answer.answer) ? _c('v-card-text', {
      staticClass: "py-1 px-3"
    }, [(answer.type === 'control_signature') ? [_c('v-subheader', {
      staticClass: "overline"
    }, [_vm._v("Signature:")]), _c('br'), _vm._v(" "), _c('img', {
      attrs: {
        "src": _vm.getRawAnswer(index, answer)
      }
    }), _vm._v(" "), (answer.prettyFormat) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.sanitize(answer.prettyFormat))
      }
    }) : _vm._e()] : _vm._e(), _vm._v(" "), (answer.type === 'control_fileupload') ? [_c('strong', [_vm._v(_vm._s(answer.text))]), _vm._v(" "), (answer.prettyFormat) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.sanitize(answer.prettyFormat))
      }
    }) : _vm._e()] : [_c('strong', [_vm._v(_vm._s(answer.text))]), _vm._v(" "), (answer.prettyFormat) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.sanitize(answer.prettyFormat))
      }
    }) : _c('div', [_vm._v(_vm._s(answer.answer))])]], 2) : _vm._e()], 1), _vm._v(" "), (answer.answer) ? _c('v-divider', {
      key: ("div-" + (_vm.submission.id) + "-" + (answer.name) + "-" + index)
    }) : _vm._e()] : _vm._e()]
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Done")])], 1)], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60684d4b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/FormSubmissionCard.vue
// module id = 1442
// module chunks = 9